<template>
  <div>
    <div
      v-if="checkoutStore.flattedEnteredKeywords.length != 0"
      class="mx-auto my-0 max-w-3xl border-t-2 px-7 pb-2 pt-10"
    >
      <p>
        <span class="text-sm font-bold uppercase"> {{ title }}:</span>
      </p>
      <template
        v-for="(criteria, criteriaName) in checkoutStore.enteredKeywords"
      >
        <template v-for="(keyword, index) in criteria" :key="keyword + index">
          <v-hover v-slot="{ isHovering, props }">
            <v-chip
              size="large"
              class="my-1 mr-1 px-5"
              pill
              variant="outlined"
              :class="computedColorPerCriteria(criteriaName, isHovering)"
              v-bind="props"
            >
              <span class="truncate text-black">{{ keyword }}</span>
              <fa-icon
                icon="fa-regular fa-xmark-large"
                class="ml-4 text-sm text-black"
                @click="removeKeyword(keyword, criteriaName)"
              />
            </v-chip>
          </v-hover>
        </template>
      </template>
    </div>
  </div>
</template>
<script>
import { mapStores } from 'pinia';
import { useCheckoutStore } from '@/stores/checkout';

export default {
  name: 'WordSelector',
  props: {
    title: {
      type: String,
      required: true,
    },
  },
  computed: {
    ...mapStores(useCheckoutStore),
  },
  created() {
    this.checkoutStore.loadSelectedKeywords();
  },
  methods: {
    async removeKeyword(keywordToDelete, criteriaName) {
      let keywords = this.checkoutStore.matchingCriteria.keywords;
      const existingIndex = this.checkoutStore.matchingCriteria.keywords[
        criteriaName
      ].findIndex((keyword) => keyword === keywordToDelete);

      if (criteriaName === 'tools') {
        this.checkoutStore.toggleSelectedTools({
          value: keywordToDelete,
        });
      }

      if (criteriaName === 'skills') {
        this.checkoutStore.toggleSelectedSkills({
          value: keywordToDelete,
        });
      }

      keywords[criteriaName].splice(existingIndex, 1);
      await this.checkoutStore.updateMatchingCriteria({
        ...this.checkoutStore.matchingCriteria,
        keywords,
      });
    },
    computedColorPerCriteria(criteria, isHovering) {
      switch (criteria) {
        case 'roles':
          return (
            'border-vgsoftblue border-1 border-solid ' +
            (isHovering ? '' : 'bg-vgsoftblue')
          );
        case 'skills':
          return (
            'border-vgsoftpurple border-1 border-solid ' +
            (isHovering ? '' : 'bg-vgsoftpurple')
          );
        case 'tools':
          return (
            'border-vgsoftcyan border-1 border-solid ' +
            (isHovering ? '' : 'bg-vgsoftcyan')
          );
        default:
          return (
            'border-vgorange-300 border-1 border-solid ' +
            (isHovering ? '' : 'bg-vgorange-300')
          );
      }
    },
  },
};
</script>
